import { getConfigValue } from "@rumble-it/common-lib/src/config";
import { UserManager, WebStorageStateStore } from "oidc-client-ts";

export const userManager = new UserManager({
  authority: `${getConfigValue("authUrl")}/realms/${getConfigValue("authRealm")}`,
  scope: "organization:* openid profile email",
  client_id: getConfigValue("authClientId"),
  redirect_uri: `${window.location.origin}${window.location.pathname}`,
  post_logout_redirect_uri: window.location.origin,
  userStore: new WebStorageStateStore({ store: window.sessionStorage }),
});

export const onSigninCallback = () => {
  window.history.replaceState({}, document.title, window.location.pathname);
};
